/**
 * Defines the columns
 * And any action against the columns
 */
export class ImportColumnsModel {
	private _columns: Array<any>;
	constructor() {
		this._columns = [
			{
				headerName: 'Provider',
				field: 'externalProvider'
			},
			{
				headerName: 'Date',
				field: 'created',
				cellRenderer: 'customDateCellComponent'
			},
			{
				headerName: 'User',
				field: 'user'
			},
			{
				headerName: 'Reference ID',
				field: 'externalId'
			},
			{
				headerName: 'Form',
				field: 'form'
			},
			{
				headerName: 'Status',
				field: 'status',
				resizable: true,
				tooltipField: 'response'
			}
		];
	}

	get columns(): Array<any> {
		return this._columns;
	}
}
